import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { USER_MANUAL_SECTIONS, ManualSection } from './user-manual-content';
import type { ManualContentBlock } from './user-manual-types';
import { AssetHeaderComponent, AssetHeaderConfig } from '../asset-header/asset-header.component';

@Component({
  selector: 'app-user-manual-overview',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, HeaderComponent, FooterComponent, AssetHeaderComponent],
  templateUrl: './user-manual-overview.component.html',
  styleUrl: './user-manual-overview.component.scss',
})
export class UserManualOverviewComponent {
  private readonly router = inject(Router);

  level1Sections: ManualSection[] = USER_MANUAL_SECTIONS.filter((s) => s.level === 1);

  sectionIcons: Record<string, string> = {
    overview: 'compass',
    'navigating-home': 'map',
    'user-login-registration-join-orgs': 'user-plus',
    'platform-capabilities': 'layers',
    'user-roles': 'users',
    'user-profile': 'user-circle',
    'help-support': 'help-circle',
  };

  assetHeaderConfig: AssetHeaderConfig = {
    breadcrumbs: [
      { label: 'Home', route: '/' },
      { label: 'User Manual', route: '/user-manual' },
    ],
    title: 'User Manual',
    description: 'Select a section to view details with images.',
  };

  getIcon(section: ManualSection): string {
    return this.sectionIcons[section.id] || 'file-text';
  }

  getPreview(section: ManualSection): string {
    if (section.content?.length) return section.content[0];
    const blocks: ManualContentBlock[] = section.contentBlocks ?? [];
    const firstText = blocks.find((b): b is Extract<ManualContentBlock, { type: 'text' }> => b.type === 'text' && !!b.text);
    if (firstText) return firstText.text;
    // Section 1: level-1 has no body in the doc; preview from 1.1 combined intro
    if (section.id === 'overview') {
      const intro = USER_MANUAL_SECTIONS.find((s) => s.id === 'intro-mahaagx');
      const text = intro?.content?.[0] ?? '';
      if (text.length > 220) return `${text.slice(0, 217).trim()}…`;
      return text;
    }
    return '';
  }

  openDetails(sectionId: string): void {
    this.router.navigate(['/user-manual', sectionId]);
  }
}

